import Grid from '@mui/material/Grid';
import { FormInput } from '../../../components/hook-form/form-input.component';
import { FormSelect } from '../../../components/hook-form/form-select.component';

export const ServiceTypeForm = () => {
  const options = [
    {
      value: true,
      label: 'Active',
      isDefault: true,
    },
    {
      value: false,
      label: 'Inactive',
      isDefault: false,
    },
  ];
  return (
    <Grid container spacing={2}>
      <Grid item lg={12} sm={12} xl={12} xs={12}>
        <FormInput label="Service Type Name" name="serviceTypeName" maxLength={150} multiline={false} autoFocus />
      </Grid>
      <Grid item lg={12} sm={12} xl={12} xs={12}>
        <FormSelect label="Status" name="isActive" options={options} />
      </Grid>
    </Grid>
  );
};
